import moment from "moment";

import { Action, State } from "common/types/redux";

import { MAX_SESSION_DURATION } from "seneca-common/constants";
import {
  analyticsCategories,
  AnalyticsEventsRegister,
  makeAnalyticsEvent,
  withLogAndSwallowError
} from "seneca-common/utils/senecaAnalytics";

import actionTypes from "../action-types";
import generateSessionAnalyticsPayload from "./payload";

const wrappedMakeSessionAnalyticsEvent = withLogAndSwallowError(
  // @ts-ignore
  makeSessionAnalyticsEvent
);

function makeSessionAnalyticsEvent(
  action: Action<Record<string, any>>,
  state: State
) {
  const { courseId, sectionIds, sessionType, timeFinished, timeStarted } =
    action.payload as any;

  const sectionId = sectionIds.size ? sectionIds.get(0) : "";

  const sessionDuration =
    timeStarted &&
    timeFinished &&
    Math.min(
      moment(timeFinished).diff(moment(timeStarted)),
      MAX_SESSION_DURATION
    );

  const payload = {
    sessionType,
    sessionDuration,
    ...generateSessionAnalyticsPayload(state, courseId, sectionId)
  };

  return makeAnalyticsEvent(analyticsCategories.SESSION, payload);
}

function makeSessionXpAnalyticsEvent() {
  return makeAnalyticsEvent(analyticsCategories.SESSION);
}

AnalyticsEventsRegister.addEventGenerators({
  [actionTypes.NEW_SESSION]: wrappedMakeSessionAnalyticsEvent,
  [actionTypes.COMPLETE_SESSION]: wrappedMakeSessionAnalyticsEvent,
  [actionTypes.UPDATE_SESSION_XP]: withLogAndSwallowError(
    makeSessionXpAnalyticsEvent as any
  )
});
